
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Paragraph, Anatomy } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Paragraph size="lead" mdxType="Paragraph">
  The <strong>in-page navigation</strong> is a vertical menu containing
  (anchored) links to H2-headings on long content pages. It{' '}
  <strong>gives the user an overview of the page contents</strong> and has a
  fixed position (does not move while scrolling) at either the{' '}
  <strong>left side of a page on desktop or top-bar on mobile</strong>. This
  component helps users scan of the page quickly contents and may potentially
  reduce vertical scrolling, allowing users to easily jump straight to the
  segment of the page.
    </Paragraph>
    <h2>{`Anatomy`}</h2>
    <Anatomy image="https://inno-ecl.s3.amazonaws.com/media/images/EC/Inpage/In-page%20navigation2.jpg" srcset="https://inno-ecl.s3.amazonaws.com/media/images/EC/Inpage/In-page%20navigation%20-%20Mobile2.jpg 598w, https://inno-ecl.s3.amazonaws.com/media/images/EC/Inpage/In-page%20navigation2.jpg 733w" alt="Anatomy of in-page navigation" legend={{
      items: [{
        color: '#404040',
        label: 'Mandatory'
      }, {
        color: '#004494',
        label: 'Optional'
      }]
    }} mdxType="Anatomy" />
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Elements`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory desktop`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Mandatory mobile`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The `}<strong parentName="td">{`heading`}</strong>{` of the in-page navigation - `}<strong parentName="td">{`Default: PAGE CONTENTS`}</strong>{` (all upper case text)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Active selection`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicator of the current segment of content`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Anchor link(s)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Actionable element corresponding to the heading (H2)`}</strong>{` of segment of content - `}<strong parentName="td">{`clicking it will jump to the H2`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Action indicator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Varies depending on the state (collapsed/expanded). `}<strong parentName="td">{`Indicates what the next action will do - displays content container on click`}</strong></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Content container`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`no`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`yes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`This element displays relevant content in a `}<strong parentName="td">{`container that's initially hidden`}</strong></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Do's`}</h2>
    <ul>
      <li parentName="ul">{`aim for `}<strong parentName="li">{`short, distinct headings (H2)`}</strong>{` in order to improve scannability and reduce possible confusion`}</li>
      <li parentName="ul">{`make sure to `}<strong parentName="li">{`order content logically so there is a natural progression when looking at the headings (H2) alone`}</strong></li>
    </ul>
    <h2>{`Don'ts`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`don't use long labels that break on the 2nd line`}</strong>{` (30 characters) `}<strong parentName="li">{`unless necessary`}</strong></li>
    </ul>
    <h2>{`When to use`}</h2>
    <ul>
      <li parentName="ul">{`when you have `}<strong parentName="li">{`more than one H2`}</strong>{` on a page`}</li>
    </ul>
    <h2>{`When not to use`}</h2>
    <ul>
      <li parentName="ul">{`don't use on a page without much content or a single H2`}</li>
      <li parentName="ul">{`don't use it to navigate beyond the page in question`}</li>
    </ul>
    <h2>{`Notes`}</h2>
    <h3>{`Design`}</h3>
    <ul>
      <li parentName="ul"><strong parentName="li">{`current selection`}</strong>{` is indicated by a gray background color and a blue line on the left (border-left)`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;